import { Container, Sprite } from '../../../odie';

import { RandomSpawnBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'assets/ui/match2/editor/icons/icon.blockmenu.randomspawn.png',
};

/*
    rocket block view
*/
export class RandomSpawnBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: RandomSpawnBlockProps) {
    // create base view
    super();

    const sprite = new Sprite(manifest.image);
    sprite.width = props.width ?? 76;
    sprite.height = props.height ?? 76;
    sprite.anchorX = 0.5;
    sprite.anchorY = 0.5;
    this.addChild(sprite);

    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [...Object.values(manifest)];
  }
}
